import styled from 'styled-components';

import { DefaultButtonStyled } from '@/components/atom/buttons/DefaultButton';
import RadioIcon from '@/components/atom/icon/checkBox/RadioIcon';
import BottomSheet from '@/components/molecules/BottomSheet';
import { useGetBoardCategoriesQuery } from '@/hooks/community/mobile/community.gql.impl';
import { boardCategoriesService } from '@/services/community';
import { BoardCategory } from '@/types/bff/gql-schema';

interface Props {
  isOpened: boolean;
  selectedCategoryId?: string;
  onClickCategory: (category: BoardCategory) => void;
  onClose: () => void;
  isFilter?: boolean;
  onClickAllCategory?: () => void;
}

const CommunityCategoryBottomSheet = ({
  isOpened,
  selectedCategoryId,
  onClickCategory,
  onClose,
  isFilter,
  onClickAllCategory,
}: Props) => {
  const { data: categories } = useGetBoardCategoriesQuery(
    {},
    {
      select: (data) => boardCategoriesService(data),
    },
  );

  return (
    <BottomSheet index={10} isOpened={isOpened} onClickOverlay={onClose}>
      <Wrapper>
        <Title>카테고리 선택</Title>
        <CategoryWrapper>
          {isFilter && (
            <Category onClick={onClickAllCategory}>
              <RadioIcon isSelected={!selectedCategoryId} />
              전체
            </Category>
          )}
          {categories?.map((category, key) => (
            <Category
              key={`category_${key}`}
              onClick={() => onClickCategory(category)}
            >
              <RadioIcon
                isSelected={category.boardCategoryId === selectedCategoryId}
              />
              {category.name}
            </Category>
          ))}
        </CategoryWrapper>
      </Wrapper>
    </BottomSheet>
  );
};

export default CommunityCategoryBottomSheet;

const Wrapper = styled.div`
  padding: 24px 0 8px;
`;

const Title = styled.div`
  padding: 0 24px 8px;
  ${({ theme }) => `
    ${theme.typography.UI20SB};
    color: ${theme.color.gray700};
  `};
`;

const CategoryWrapper = styled.div``;

const Category = styled(DefaultButtonStyled)`
  padding: 12px 24px;
  width: 100%;
  justify-content: flex-start;

  svg {
    margin-right: 12px;
  }

  ${({ theme }) => `
    ${theme.typography.UI16M};
    color: ${theme.color.gray500};

    &: active {
      background: ${theme.color.gray50};
    }
  `};
`;
